import { render, staticRenderFns } from "./biddingDetail.vue?vue&type=template&id=6909e11e&scoped=true&"
import script from "./biddingDetail.vue?vue&type=script&lang=js&"
export * from "./biddingDetail.vue?vue&type=script&lang=js&"
import style0 from "./biddingDetail.vue?vue&type=style&index=0&id=6909e11e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6909e11e",
  null
  
)

export default component.exports